import {percentageGroup} from "../../utils/step.fields.utils";

const step_schema_sme = [
    // todo add disclaimer - all uk licence, more than 1 year
    // todo add t&cs

    //company
    {
        key: 'company_name',
        percentage_group: percentageGroup.PERCENTAGE_COMPANY
    },
    {
        key: 'postcode',
        label: 'What is your business premises postcode?',
        placeholder: 'Premises Postcode',
        type: 'address-lookup-step',
        headline: 'Company',
        percentage_group: percentageGroup.PERCENTAGE_COMPANY
    },
    {
        key: 'address1',
        skip_question: true
    },
    {
        key: 'address2',
        skip_question: true
    },
    {
        key: 'address3',
        skip_question: true
    },
    {
        key: 'address4',
        skip_question: true
    },
    {
        key: 'city',
        skip_question: true
    },
    {
        key: 'company_age',
        percentage_group: percentageGroup.PERCENTAGE_COMPANY
    },
    {
        key: 'company_business',
        percentage_group: percentageGroup.PERCENTAGE_COMPANY,
    },
    //proposer
    {
        key: 'contact_name',
    },
    {
        key: 'telephone',
    },
    {
        key: 'email',
    },
    //policy
    {
        key: 'cover_level',
    },
    {
        key: 'marketing',
        extra_children: [
            {
                key: 'marketing_phone',
            },
            {
                key: 'marketing_email',
            },
            {
                key: 'marketing_sms',
            },
        ],
    },
    {
        key: 'end',
    },
];
export default step_schema_sme;
